export var ComponentAdjustmentEnum;
(function (ComponentAdjustmentEnum) {
    ComponentAdjustmentEnum["HIT_POINT_SPEED_ADJUSTMENT"] = "speed";
})(ComponentAdjustmentEnum || (ComponentAdjustmentEnum = {}));
